<template>
  <!-- header start -->
  <header id="header" class="header-wrapper home-parallax home-fade">
    <div class="header-overlay"></div>
    <div class="header-wrapper-inner">
      <div class="container">
        <div class="welcome-speech">
          <!-- <h1>Crie sua identidade e venda mais!</h1> -->
          <h1>Venda mais inovando na internet!</h1>
          <p>
            Tudo que você precisa para criar sua marca e mostrá-la para o mundo.
          </p>
          <!-- <a href="#" class="btn btn-white"> Nossos trabalhos </a> -->
        </div>
        <!-- /.intro -->
      </div>
      <!-- /.container -->
    </div>
    <!-- /.header-wrapper-inner -->
  </header>
  <!-- /#header -->
</template>

<script>
export default {
  name: "HeaderHomeSection",
};
</script>

<style scoped>
.header-wrapper .header-wrapper-inner .welcome-speech {
  margin-top: -13em;
}

.welcome-speech h1 {
  color: white;
  text-shadow: -2px -2px 0 #000, 2px -2px 0 #000, -2px 2px 0 #000,
    2px 2px 0 #000, -2px 0 0 #000, 2px 0 0 #000, 0 -2px 0 #000, 0 2px 0 #000;
}
</style>
